import React, {Component} from 'react'
import jwtDecode from 'jwt-decode';
import Config from '../../config'

class UserBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            assimilateBoxVisible: ''
        };
    }

    componentDidMount() {
        if (localStorage.getItem('apitoken')) {
            let token = localStorage.getItem('apitoken');
            let userInfo = jwtDecode(token);

            this.setState({
                firstName: userInfo.Firstname,
                lastName: userInfo.Lastname
            });
        }
    }

    goBack() {
      localStorage.setItem('apitoken', localStorage.getItem('apitoken_original'));
      localStorage.removeItem('WheelChangerId');
      localStorage.removeItem('apitoken_original');
      window.location.reload();
    }

    render() {
        const {firstName, lastName} = this.state;

        const wheelChangersBox = (
          <div className='wheelchangers-box'>
          </div>
        );

        let title = "Inloggad som";
        if (Config.api.getTokenOriginal()){
            title = "Assimilerad som";
        }

        return (
            <div id="UserBox">
                {
                    Config.api.getTokenOriginal() &&
                    <span className='assimilate' onClick={this.goBack}>
                      {this.state.assimilateBoxVisible && wheelChangersBox}
                    </span>
                }
                <span>{title}</span>
                <div className='user-type'>
                    {firstName + ' ' + lastName}
                </div>
            </div>
        );
    }
}

export default UserBox;


// WEBPACK FOOTER //
// ./src/components/UserBox/index.js